import { useEffect } from 'react';

export function useAutoResize(
  textareaRef: React.RefObject<HTMLTextAreaElement>,
  value: string
) {
  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, [value, textareaRef]);
}
